import { Autocomplete } from '@material-ui/lab';
import { Chip, TextField, makeStyles } from '@material-ui/core';
import { Machine } from '../../../model/customer-machine';
import { MachineCard } from './machine-card';
import { filter } from 'lodash';
import { useIntl } from 'react-intl';

const getOptionLabel = (option: any) => option.name;

const renderOption = (machine: any) => (
  <MachineCard machine={machine} />
);

const renderTags = (value: any, getTagProps: any) =>
  value.map((option: any, index: number) => (
    <Chip style={{ height: '28px' }} variant="outlined" label={option.name} {...getTagProps({ index })} />
  ));

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    height: 'auto',
    minHeight: 48,
    flexWrap: 'wrap', // allow wrapping of chips
    alignItems: 'flex-start !important', // align input properly
    '& .MuiChip-root': {
      margin: theme.spacing(0.5, 0.25),
    },
  },
  inputLabel: {
    transform: 'translate(14px, 18px) scale(1)', // default MUI position +2px down
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)', // default shrunk position
    },
  },
  option: {
    padding: 0,
  },
}))

export const MachineInput = ({ options, ...props }: { [key: string]: any, options: any[] }) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      style={{ width: '100%' }}
      classes={{
        option: classes.option,
        inputRoot: classes.inputRoot,
      }}
      options={options}
      autoHighlight
      filterOptions={(options: Machine[], { inputValue }) => {
        if (!inputValue || !options?.length) {
          return options;
        }

        return filter(options, (o: Machine) => {
          return o.description?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
            || o.name?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase());
        });
      }}
      getOptionLabel={getOptionLabel}
      renderOption={renderOption}
      renderInput={(params) => (
        <TextField
          {...params}
          label={intl.formatMessage({ id: 'statistics.graph.machineIdsFilter' })}
          variant="outlined"
          InputLabelProps={{
            classes: { root: classes.inputLabel },
          }}
          placeholder={intl.formatMessage({ id: 'customer-article.machines.label' })}
          inputProps={{
            ...params.inputProps,
            style: {
              width: '100%',
            },
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
      renderTags={renderTags}
      {...props}
    />
  );
};
